const VERSION_FORCE_KEY = "app-version-force";

export const APP_VERSION = __APP_VERSION__;

export function getAppVersionLabel() {
	const separatorIndex = APP_VERSION.indexOf("-");

	if (separatorIndex === -1) {
		return `v${APP_VERSION}`;
	}

	const packageVersion = APP_VERSION.slice(0, separatorIndex);

	return `v${packageVersion}`;
}

export async function refreshOnNewVersion() {
	if (import.meta.env.DEV) {
		return false;
	}

	try {
		const versionUrl = new URL("version.json", window.location.origin + import.meta.env.BASE_URL);
		versionUrl.searchParams.set("t", Date.now().toString());

		const response = await fetch(versionUrl.toString(), {
			cache: "no-store",
			headers: {
				"cache-control": "no-cache",
			},
		});

		if (!response.ok) {
			return false;
		}

		const payload = (await response.json()) as { version?: string };
		const latestVersion = payload.version;

		if (!latestVersion || latestVersion === APP_VERSION) {
			sessionStorage.removeItem(VERSION_FORCE_KEY);
			return false;
		}

		if (sessionStorage.getItem(VERSION_FORCE_KEY) === latestVersion) {
			return true;
		}

		sessionStorage.setItem(VERSION_FORCE_KEY, latestVersion);

		if ("caches" in window) {
			const cacheKeys = await window.caches.keys();
			await Promise.all(cacheKeys.map(cacheKey => window.caches.delete(cacheKey)));
		}

		const nextUrl = new URL(window.location.href);
		nextUrl.searchParams.set("v", latestVersion);
		window.location.replace(nextUrl.toString());
		return true;
	} catch {
		return false;
	}
}
